import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { JobOverviewModel } from '../state';

export const JOB_OVERVIEW_MODELS = new InjectionToken<Observable<JobOverviewModel[]>>('Job Overview Models');
